<template>
  <form ref="formElement" @submit.prevent="submit">
    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxSelect name="country" :items="countries" :form="formName" required>Shopify Site</SaxxSelect>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxSelect name="group_name" :items="group_names" :form="formName">Reason</SaxxSelect>
      </el-col>
      <el-col :span="12">
        <SaxxSelect name="group_detail" :items="group_details" :form="formName">Details</SaxxSelect>
      </el-col>
    </el-row>
    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxText name="code" :form="formName" required>Code</SaxxText>
      </el-col>
      <el-col :span="12">
        <SaxxSelect name="authorized_reseller" :items="authorizedResellerOptions" :form="formName" required>
          Authorized Reseller
        </SaxxSelect>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxSelect name="type" :items="types" :form="formName" required>Type</SaxxSelect>
      </el-col>
      <el-col :span="12">
        <SaxxText pattern="\d*" name="amount" :form="formName" :validator="amountValidator">Amount</SaxxText>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxSelect
            name="tracker_prefix"
            :items="tracker_prefixes"
            :form="formName"
            required
        >Family Prefix
        </SaxxSelect>
      </el-col>
      <el-col :span="12">
        <SaxxSelect
            name="tracker_detail"
            :items="tracker_details"
            :form="formName"
            required
        >Family Details
        </SaxxSelect>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxSelect name="size" :items="sizes" :form="formName">Size</SaxxSelect>
      </el-col>
      <el-col :span="12">
        <SaxxSelect name="factory" :items="factories" :form="formName">Factory</SaxxSelect>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxSelect name="supplier" :items="suppliers" :form="formName">Source of Purchase</SaxxSelect>
      </el-col>
      <el-col :span="12">
        <SaxxText name="retailer_name" :form="formName">Name of Retailer</SaxxText>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxText name="product_sku" :form="formName">
          Product SKU
          <small>*saxx.com purchaes only</small>
        </SaxxText>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxText name="customer_first_name" :form="formName">First Name</SaxxText>
      </el-col>

      <el-col :span="12">
        <SaxxText name="customer_last_name" :form="formName">Last Name</SaxxText>
      </el-col>
    </el-row>
    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxText name="customer_email" :form="formName">Email</SaxxText>
      </el-col>

      <el-col :span="12">
        <SaxxText name="customer_phone" :form="formName">Phone</SaxxText>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="12">
        <SaxxText name="order_number" :form="formName">Order Number</SaxxText>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col :span="24">
        <SaxxText name="img_url" :form="formName">Image URL</SaxxText>
      </el-col>
    </el-row>
    <el-row :gutter="32">
      <el-col :span="24">
        <SaxxTextArea name="reason" :form="formName">Comments</SaxxTextArea>
      </el-col>
    </el-row>

    <slot>
      <el-row :gutter="32">
        <el-col :span="24">
          <ElButton type="primary" native-type="submit" :disabled="isLoading">Submit</ElButton>
        </el-col>
      </el-row>
    </slot>
  </form>
</template>

<script>
import axios, {RepositoryError} from "../../repositories";
import {mapActions, mapGetters} from "vuex";
import {notify} from "../../utils";
import FormSelect from "../forms/FormSelect";
import SaxxText from "../forms/SaxxText";
import SaxxSelect from "../forms/SaxxSelect";
import SaxxTextArea from "../forms/SaxxTextArea";

export default {
  name: "CouponForm",
  components: {
    SaxxText,
    FormSelect,
    SaxxSelect,
    SaxxTextArea
  },
  props: {
    formName: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      countries: [
        {label: "USA", value: "usa"},
        {label: "Canada", value: "ca"},
      ],
      types: [
        {label: "Fixed amount", value: "fixed"},
        {label: "Percentage discount", value: "percentage"}
      ],
      group_names: [],
      group_details_by_name: {},
      sizes: [],
      factories: [],
      suppliers: [],
      tracker_prefixes: [],
      tracker_details_by_prefix: {},
      authorizedResellerOptions: [
        {label: 'Y', value: 'Y'},
        {label: 'N', value: 'N'},
        {label: 'N/A', value: 'N/A'},
      ],
    };
  },
  created() {
    this.createForm({
      name: this.formName,
      fields: {
        country: "",
        code_type: "",
        tracker_prefix: "",
        tracker_detail: "",
        group_name: "",
        group_detail: "",
        code: "",
        type: "",
        amount: 0,
        customer_first_name: "",
        customer_last_name: "",
        customer_email: "",
        customer_phone: "",
        size: "",
        factory: "",
        supplier: "",
        retailer_name: "",
        product_sku: "",
        order_number: "",
        img_url: "",
        reason: "",
        authorized_reseller: "",
      }
    });

    this.fetchCouponConfig();
    this.$emit('created');
  },
  methods: {
    ...mapActions("forms", ["createForm", "setField"]),
    submit() {
      if (!this.$refs.formElement.checkValidity()) {
        return this.$refs.formElement.reportValidity();
      }

      // if (
      //     !this.tracker_details.find(v => v.value === this.fields.tracker_detail)
      // ) {
      //   this.setField({
      //     form: this.formName,
      //     field: "tracker_detail",
      //     value: ""
      //   });
      //   notify(
      //       "The Family Details field was incorrectly set. Please set it now!",
      //       "danger"
      //   );
      //   return;
      // }

      this.$emit("submit", {...this.fields});
    },
    async fetchCouponConfig() {
      try {
        const res = await axios.get("/discounts/get-coupon-config");
        const config = res.data;

        let group_details_by_name = {};
        Object.keys(config.couponGroupDetail).forEach(key => {
          group_details_by_name[key] = config.couponGroupDetail[key].map(v => ({
            label: v,
            value: v
          }));
        });

        let tracker_details_by_prefix = {};
        Object.keys(config.guaranteeTrackerDetail).forEach(key => {
          tracker_details_by_prefix[key] = config.guaranteeTrackerDetail[
              key
              ].map(v => ({label: v, value: v}));
        });

        this.group_details_by_name = group_details_by_name;
        this.tracker_details_by_prefix = tracker_details_by_prefix;
        this.group_names = config.couponGroup;
        this.sizes = config.size.map(v => ({label: v, value: v}));
        this.factories = config.factory.map(v => ({label: v, value: v}));
        this.suppliers = config.supplier.map(v => ({label: v, value: v}));
        this.tracker_prefixes = config.guaranteeTracker.map(v => ({
          label: v,
          value: v
        }));
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    }
  },
  computed: {
    ...mapGetters("forms", ["getFields", "getStatus"]),
    fields() {
      return this.getFields({
        form: this.formName
      });
    },
    isLoading() {
      return this.getStatus({form: this.formName}) === "loading";
    },
    group_details() {
      if (String(this.fields.group_name).trim() === "") {
        return [];
      }

      return this.group_details_by_name[this.fields.group_name] || [];
    },
    tracker_details() {
      if (String(this.fields.tracker_prefix).trim() === "") {
        return [];
      }

      return this.tracker_details_by_prefix[this.fields.tracker_prefix] || [];
    },
    amountValidator() {
      if (this.fields.type === "") {
        return () => true;
      }

      switch (this.fields.type) {
        case "percentage":
          return v => v >= 0 && v <= 100;
        case "fixed":
        default:
          return v => v >= 0;
      }
    }
  },
  watch: {
    "fields.group_name": function (_, prevGroupName) {
      if (this.isLoading || prevGroupName === "") {
        return;
      }

      this.setField({
        form: this.formName,
        field: "group_detail",
        value: ""
      });
    },
    "fields.tracker_prefix": function (prefix, prevPrefix) {
      if (this.isLoading || prevPrefix === "") {
        return;
      }

      this.setField({
        form: this.formName,
        field: "code_type",
        value: `${prefix}`
      });
    },
    "fields.tracker_detail": function (detail, prevDetail) {
      if (this.isLoading || prevDetail === "") {
        return;
      }

      this.setField({
        form: this.formName,
        field: "code_type",
        value: `${this.fields.tracker_prefix}/${detail}`
      });
    },
    "fields.type": function (_, prevType) {
      if (this.isLoading || (this.fields.amount > 0 && prevType === "")) {
        return;
      }

      this.setField({
        form: this.formName,
        field: "amount",
        value: 0
      });
    }
  }
};
</script>

<style>
.el-row {
  margin-bottom: 32px;
}
</style>
